export { ZapierLogoSymbol } from './ZapierLogoSymbol';
